export default __webpack_public_path__ + "static/media/new-icon.7bd77337.svg";